<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import AuthApi from "@/services/auth-api";
import Vue from 'vue'

import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import UsersApi from "@/services/users-api";

/**
 * Login component
 */
export default {
  page: {
    title: "Authentification",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, NprogressContainer, FormWizard, TabContent,WizardStep },
  data() {
    return {
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,

      forgetPasswordisClicked:false,
      createNewAccountClicked:false,

      newPassword:"",
      confPassword:"",
      username:"",
      errorMessage:"",
      showErrorMesage:false,
      tryingToCreateCode:false,
      code:"",
      showSecondErrorMessage:false,
      secondErrorMessage:"",

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,

      passwordHidden: true,
    };
  },
  computed:{
    getPrimaryColor(){
      return   process.env.VUE_APP_PRIMARY_COLOR;
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;
      // Reset the authError if it existed.
      this.authError = null;
      return (
        this.logIn({
          email: this.email,
          password: this.password
        })
          // eslint-disable-next-line no-unused-vars
          .then(token => {
            this.tryingToLogIn = false;
            this.isAuthError = false;

            // Redirect to the originally requested page, or to the home page
            if (this.$route.query.redirectFrom == "/logout") {
              this.$router.push({ name: "default" });
            } else {
              this.$router.push(
                /*this.$route.query.redirectFrom ||*/ { name: "default" }
            );
            }
          })
          .catch(error => {

            this.tryingToLogIn = false;
            this.authError = error ? error : "";
            this.isAuthError = true;

            Vue.prototype.$snotify.error(this.authError);
          })
      );
    },

    openForgetPassword(){
      this.forgetPasswordisClicked=true
      this.newPassword=""
      this.confPassword=""
      this.username=""
      this.errorMessage=""
      this.showErrorMesage=false
      this.tryingToCreateCode=false
      this.code=""
      this.showSecondErrorMessage=false
      this.secondErrorMessage=""
      this.isAuthError=false
    },

    openCreateNewAccount() {
      this.createNewAccountClicked=true
    },

    _handleError(error) {
        this.errorMessage=error
        this.showErrorMesage=true
    },

    _handleSecondError(error) {
        this.secondErrorMessage=error
        this.showSecondErrorMessage=true
    },

    createCode () {

      return new Promise((resolve, reject) => {
          AuthApi.createCode(this.username,this.newPassword,this.confPassword)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleError(error));
          });
      });
    },

    resetPassword () {
      return new Promise((resolve, reject) => {
          AuthApi.resetPassword(this.username,this.code)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleSecondError(error));
          });
      });
    },

    addAccountRequest() {
        UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(
              (result) => {
                  if (result) {
                    Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
                    this.newAccountCompanyName = null;
                    this.newAccountCompanyPhone = null;
                    this.createNewAccountClicked=false;
                  }
              }
            ).finally(()=>{
            })
      },

  },

  mounted() {
      document.body.style.background='##fff';
  }
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: $primary;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
    border: solid 4px transparent;
    border-top-color: $primary;
    border-left-color: $primary;
  }

  #nprogress .peg {
    box-shadow: 0 0 10px grey, 0 0 5px grey;
    opacity: 1.0;
  }







</style>

<template>
  <Layout class="nprogress-container auth" >
      <nprogress-container></nprogress-container>

     <!-- <div class="row bg-white p-2 ">

          <div class="col-3 my-auto text-center">
            <router-link to="/" >
              <svg  enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24">
                <path d="M21,11v1H5.64l6.72,6.72l-0.71,0.71L3.72,11.5l7.92-7.92l0.71,0.71L5.64,11H21z"></path>
              </svg>
              <span class="text-dark ml-2 font-size-16 d-none d-sm-inline">Retour</span>
            </router-link>
          </div>

          <div class="col-6  text-center">

            

            

            <router-link to="/" >
              <img src="@/assets/images/logo.png" alt height="50" />
            </router-link>
          </div>
      </div> -->

      <div class="row pt-4 pb-2 mb-2 d-lg-block d-xl-block d-none" >
          <div class="col-12 text-center ">
              <!-- <h2 class="text-dark">Connectez-vous ou créez un compte professionnel</h2>
              <h5>Consultez le catalogue et commandez à prix négociés</h5> -->
              <h2>&nbsp;</h2>
          </div>
      </div>
      <div class="row pt-4 pb-2 mb-2 d-lg-block d-xl-block d-none" >
          <div class="col-12 text-center ">
              <!-- <h2 class="text-dark">Connectez-vous ou créez un compte professionnel</h2>
              <h5>Consultez le catalogue et commandez à prix négociés</h5> -->
              <h2>&nbsp;</h2>
          </div>
      </div>

      <div class="row  justify-content-center pt-md-4">

          <!-- LOGIN FORM -->
          <div class="col-xl-6 col-lg-8 col-md-12 col-sm-12 col-xs-12  p-lg-2 p-md-2 p-0" style="opacity:0.95;">

              <div class="card overflow-hidden login-card-border" style="">

                <div class="row p-4">
                  <div class="col-lg-12 col-md-0 text-center">

                    <router-link to="/" >
                      <img src="@/assets/images/cab/logo.png" alt height="50" />
                    </router-link>

                  </div>

                  
                </div>

                

                <div class="row p-0">
                  
                  <div class="col-lg-2 col-md-0 "></div>

                  <!-- LOGIN FORM -->
                  <div class=" col-lg-8 col-md-12 col-sm-12 col-xs-12 " >

                    <div v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="row pr-4 mt-1 pt-4 pl-4">
                      <div class="col-12 text-right">
                        <div class="text-primary pr-2 pl-0 pb-2">
                          <h5 class="text-primary font-weight-bold font-size-20 text-center">Site de commande en ligne pour les <span class="text-success">Pharmaciens</span></h5>
                          <h5 class="text-dark font-size-16 text-center">Connectez-vous avec votre email et mot de passe <sup>*</sup></h5>
                        </div>
                      </div>
                    </div>


                  <div class="card-body pt-0 pb-1" >
                    
                    <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

                    <!-- PASSWORD REINIT -->
                    <div v-if="forgetPasswordisClicked && !createNewAccountClicked" >

                      <div  class="row  mt-1 pt-4 ">
                      <div class="col-12 text-right">
                        <div class="text-primary pr-2 pl-0 pb-2">
                          <h5 class="text-primary font-weight-bold font-size-20 text-center">Mot de passe oublié ?</h5>
                          <h5 class="text-dark font-size-16 text-center">Suivez les étapes ci-dessous pour le réinitialiser
                            <!-- <a style="cursor:pointer;" class="font-weight-bold text-primary" @click="forgetPasswordisClicked=false"> Retour</a> -->
                          </h5>

                          

                        </div>
                      </div>
                    </div>

                      <form-wizard  class="mt-4" :color="getPrimaryColor"  nextButtonText="Suivant" finish-button-text="Terminer" @on-complete="forgetPasswordisClicked=false">
                          <div slot="prev" scope="props" class="d-none">                      
                          </div>
                          <template slot="step" slot-scope="props">
                            <wizard-step :tab="props.tab"
                            :transition="props.transition"
                            
                            :index="props.index">
                            </wizard-step>
                          </template> 
                        <tab-content icon="mdi mdi-account-circle"  :before-change="createCode">
                          <div class="row mb-4">
                            <div class="col-12">
                                <b-alert v-show="showErrorMesage" show variant="danger">{{this.errorMessage}}</b-alert>

                                <label class="mb-2" >Adresse Mail</label>
                                <input
                                  class="form-control"
                                  v-model="username"
                                  type="text"
                                  placeholder="Adresse Mail"
                                  autocomplete="off"
                                />
                                <label class="mb-2 mt-4" for="pwd">Nouveau Mot de passe</label>
                                <input
                                  class="form-control"
                                  id="pwd"
                                  v-model="newPassword"
                                  type="password"
                                  placeholder="Nouveau Mot de passe"
                                  autocomplete="off"
                                />
                                <label class="mb-2 mt-4" for="confpwd">Retapez le nouveau mot de passe</label>
                                <input
                                  class="form-control"
                                  id="confpwd"
                                  v-model="confPassword"
                                  type="password"
                                  placeholder="Mot de Passe de Confirmation"
                                  autocomplete="off"
                                />
                            </div>
                          </div>
                        </tab-content>
                        <tab-content icon="mdi mdi-lock" :before-change="resetPassword" >
                          <div class="row">
                            <div class="col-12">
                                <b-alert v-show="showSecondErrorMessage" show variant="danger">{{this.secondErrorMessage}}</b-alert>
                                <div class="row mb-4">
                                  <div class="col-12 text-center text-primary">
                                  <i class="bx bx-hourglass bx-spin mr-2"></i>Un code a été envoyé à l'adresse <span class="font-weight-bold">{{this.username}}. </span> Ce code expire dans <span class="font-weight-bold">15 minutes</span>
                                  </div>
                                </div>
                                <input
                                  class="form-control mb-4"
                                  v-model="code"
                                  type="text"
                                  placeholder="Saisir le Code"
                                  autocomplete="off"
                                />
                            </div>
                          </div>
                        </tab-content>
                        <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                          <div class="row mb-4">
                            <div class="col-12">
                              <div class="text-center">
                                <h2 class="mt-0">
                                  <i class="mdi mdi-check-all text-success"></i>
                                </h2>
                                <h3 class="mt-0">Félicitations !</h3>

                                <p class="w-75 mb-2 mx-auto">
                                  Votre mot de passe a été réinitialisé avec succés.
                                </p>

                              </div>
                            </div>
                          </div>
                        </tab-content>
                      </form-wizard>
                      <div class="row">
                        <div class="col-12 text-dark text-center" >
                          <i class="mdi mdi-lock mr-1"></i> Vous vous en souvenez ?               
                            <div
                            style="cursor:pointer;"
                            @click="forgetPasswordisClicked=false"
                            class="font-weight-bold text-primary"
                            >Connectez-vous ici</div
                        > 
                        </div>
                      </div>
                    </div>
                    <!-- END PASSWORD REINIT -->

                    <!-- PRO ACCOUNT CREATION -->
                    <div v-if="!forgetPasswordisClicked && createNewAccountClicked" >
                      <div  class="row  mt-1 pt-4 ">
                      <div class="col-12 text-right">
                        <div class="text-primary pr-2 pl-0 pb-2">
                          <h5 class="text-success font-weight-bold font-size-20 text-center">
                            <span class="d-none d-sm-inline">Créer un compte professionnel ?</span>
                            <span class="d-sm-none">Créer un compte pro ?</span>
                          </h5>
                          <h5 class="text-dark font-size-16 text-center">Suivez les étapes ci-dessous pour le réinitialiser</h5>
                        </div>
                      </div>
                      </div>

                      <div class="row mt-4">
                                  <div class="col-12">
                                    <span class="text-secondary font-size-12" style="text-align:justify;">
                                      Envoyer nous le nom de votre société, votre numéro de téléphone ou adresse mail 
                                      et <u>demandez votre inscription à l'espace des clients professionnels.</u>
                                    </span>
                                  </div>
                              </div>

                      <b-form   class="pt-4 pb-2 pr-4 pl-4 mt-2" >
                      

                      <b-form-group class="text-dark mt-4" id="input-group-2"  label-for="input-2">

                        

                        <b-form-input
                        class="font-size-16 text-dark border border-dark"
                          
                          v-model="newAccountCompanyName"
                          placeholder="Nom de société"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group class="text-dark" id="input-group-1"  label-for="input-1">
                        <b-form-input class="font-size-16 text-dark border border-dark" 
                              @keyup.native.enter="addAccountRequest()"
                              v-model="newAccountCompanyPhone"  placeholder="Numéro de Téléphone ou Adresse mail"></b-form-input>
                      </b-form-group>
                      
                      
                      <div class="mt-4">
                        <b-button  variant="success" 
                        @click="addAccountRequest()"
                        class="btn-block font-weight-bold text-white font-size-20">Envoyer la demande</b-button>
                      </div>
                      <!-- <div class="mt-4 text-center text-info font-size-15">
                      </div> -->
                      
                    </b-form>

                    

                    <div class="row mt-4">
                        <div class="col-12 text-dark text-center" >
                          <i class="mdi mdi-lock mr-1"></i> Vous avez déjà un compte ?               
                          <div
                          style="cursor:pointer;"
                          @click="createNewAccountClicked=false"
                          class="font-weight-bold text-primary"
                          >Connectez-vous ici</div
                        > 
                        </div>
                      </div>

                      
                    </div>
                    <!-- END PRO ACCOUNT CREATION -->

                    <b-form  v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="pt-4 pb-2 pr-4 pl-4 mt-2" @submit.prevent="tryToLogIn">
                      <b-form-group class="text-dark" id="input-group-1"  label-for="input-1">
                        <b-form-input class="font-size-16 text-dark border border-dark" id="input-1" v-model="email" type="email" placeholder="Adresse mail"></b-form-input>
                      </b-form-group>

                      <b-form-group class="text-dark mt-4" id="input-group-2"  label-for="input-2">
                        <b-input-group >
                          <b-form-input
                          class="font-size-16 text-dark border border-dark"
                            id="input-2"
                            v-model="password"
                            :type="passwordHidden ? 'password':'text'"
                            placeholder="Mot de passe"
                            autocomplete="off"
                            style="border-right:0px !important;"
                          ></b-form-input>

                          <template v-slot:append>
                              <b-button  size="sm" variant="dark"  class="bg-white" style="border-left:0px !important;"  @click="passwordHidden = !passwordHidden"  >
                                <i :class="passwordHidden ?'fa fa-eye-slash text-dark':'display-eye fa fa-eye text-danger'"  ></i>
                              </b-button>
                          </template>
                        </b-input-group>
                      </b-form-group>
                      <div class="mt-3 text-left">
                        <!-- <router-link tag="a" to="/forgot-password" class="text-muted"> -->
                        <div class="text-info font-weight-bold" @click="openForgetPassword" style="cursor: pointer">
                          <i class="mdi mdi-lock mr-1"></i>Mot de passe oublié ?
                        </div>
                      </div>
                      
                      <div class="mt-4">
                        <b-button type="submit" variant="primary" class="btn-block font-weight-bold text-white font-size-20">Connecter</b-button>
                      </div>
                      <!-- <div class="mt-4 text-center text-info font-size-15">
                      </div> -->
                      
                    </b-form>
                    
                    <p v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="pt-4 pr-4 pl-4 pb-0 font-size-11 text-muted" style="text-align:justify;">
                      
                      * Nous collectons des informations dans le but d'améliorer nos services et votre expérience lors de l'utilisation du site. 
                      En vous connectons vous acceptez les conditions d'utilisation du site.
                    </p>

                    </div>

                    <hr class="hr-text" data-content="OU" v-if="!forgetPasswordisClicked && !createNewAccountClicked"/>
                  </div>
                  <!-- end card-body -->

                  </div>

                  <div v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="row pr-md-4 pl-md-4 mr-4 ml-4 mb-4">

                      <!-- <div class=" col-lg-8 col-md-12 col-sm-12 text-left d-lg-inline d-none">
                          <h5 class="text-secondary font-size-20 font-weight-bold"><u>Demandez un compte Pro ?</u></h5>
                          
                            <span class="text-secondary font-size-12 pr-4" style="text-align:justify;">
                            Commandez à prix négociés, suivez, automatisez et accélérer le traitement de vos commandes.</span>

                      </div> -->

                      <div class="col-lg-3 col-md-12 col-sm-12 pt-lg-0 pt-4 text-center"></div>
                      <div class="col-lg-6 col-md-12 col-sm-12 pt-lg-0 pt-4 text-center">

                          <b-button variant="outline-secondary" @click="openCreateNewAccount()" class="w-100" >
                              <span class=" font-weight-bold font-size-16" style="font-weight:600;">Demander un compte Pro</span>
                          </b-button>

                      </div>

                      
                  </div>






              </div>

          </div>

      </div>

      

<!-- Mobile version -->
 <!-- <div class="card border-white overflow-hidden d-sm-none " style="border: 2px solid;">

          <div class="bg-white">
            <div class="row">
              <div class="col-12 p-4 align-self-end">
                <img src="@/assets/images/logo-title.jpg" alt class="img-fluid" />
              </div>
            </div>
          </div>

          <div class="card-body pt-3">

            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group id="input-group-1" label="Adresse Mail" label-for="input-1">
                <b-form-input  v-model="email" type="email" placeholder="Votre email"></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-2" label="Mot de Passe" label-for="input-2">
                <b-form-input
                  v-model="password"
                  type="password"
                  placeholder="Mot de passe"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              <div class="mt-5">
                <b-button type="submit" variant="primary" class="btn-block font-weight-bold font-size-16">Connecter</b-button>
              </div>
              <div class="mt-4 text-center text-info font-size-15">
              </div>
              <div class="mt-3 text-center">
             
              </div>
            </b-form>
          </div>
          

          
        </div>

         <div class="container-fluid" style="background-color:#2a3042;">
      <div class="row p-3 pl-2 pr-2">
        <div class="col-sm-4 my-auto d-none d-sm-block font-weight-bold text-white"><span class="text-primary">LGP</span> - Le Groupement Pharmaceutique</div>
        
        

        <div class="col-sm-4 ">
          <div class="text-sm-center text-right font-weight-bold  text-white">Contact : <a href="mailto:contact@lgp.tn">contact@lgp.tn</a></div>
        </div>

        <div class="col-sm-4 ">
          <div class="text-right text-white">Powered by <a href="http://www.amiral.io" target="_blank">Amiral</a></div>
        </div>

      </div>
    </div> -->

  </Layout>
</template>

<style scoped>


.auth {
  background-image: url('~@/assets/images/cab/background/back.jpg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  height: 1080px;
}
</style>


<style lang="scss" >

::v-deep .vue-form-wizard .wizard-navigation .wizard-icon-circle{
  background-color: $primary; 
}


</style>


